//M10-12866
import React from "react";

interface ToggleButtonProps {
  isOn: boolean;
  onClick: () => void;
  disabled?: boolean; //M10-15149
}

const ToggleButton: React.FC<ToggleButtonProps> = ({ isOn, onClick, disabled }) => {
  return (
    <button
      onClick={onClick}
      disabled={disabled} //M10-15149
      className={`w-12 h-6 rounded-full transition-colors duration-200 flex items-center px-1 disabled:opacity-50 disabled:cursor-not-allowed
        ${isOn ? "bg-blue-500 justify-end" : "bg-gray-300 justify-start"}`}
    >
      <span className="w-4 h-4 bg-white rounded-full shadow-md" />
    </button>
  );
};

export default ToggleButton;
//M10-12866